import { format } from 'date-fns';
const localePrefers24HourClock = language => {
  try {
    const {
      hour12
    } = new Intl.DateTimeFormat(language, {
      hour: 'numeric',
      minute: 'numeric'
    }).resolvedOptions();
    return hour12 === false;
  } catch {
    return false;
  }
};
export const getDifferenceInMinutesFromNow = endDate => {
  const now = new Date().getTime();
  endDate = new Date(endDate * 1000).getTime();
  const difference = endDate - now;
  const minutes = Math.floor(difference % (1000 * 60 * 60) / (1000 * 60));
  const seconds = Math.floor(difference % (1000 * 60) / 1000);
  const time = `${minutes}:${('0' + seconds).slice(-2)}`;
  return {
    time,
    difference
  };
};
export const formatTimestamp = (unixTimestamp = 0, language = 'en-US', monthFormat = 'MMMM d') => {
  const date = new Date(unixTimestamp * 1000);
  const time = localePrefers24HourClock(language) ? format(date, 'HH:mm') : format(date, 'h:mma').toLowerCase();
  return {
    time,
    monthDate: format(date, monthFormat)
  };
};